import { en, t as tShared, type MessageKey as SharedMessageKey, type MessageVars } from '@cattle/money'

import { messages, type ConsoleMessageKey } from './messages'

/**
 * `t()` for the consoles.
 *
 * `@cattle/money` owns the dictionary the trader's phone app renders from, and
 * that is where every shared string (roles, breeds, statuses, common actions)
 * still lives — this function delegates to it for those keys. The consoles add
 * several hundred strings of their own, which are merged in here rather than
 * pushed upstream into a bundle that ships to a phone.
 *
 * The key type is the union of both dictionaries, so a typo is still a build
 * error rather than a blank label found by the reader.
 */
export type MessageKey = SharedMessageKey | ConsoleMessageKey

const PLACEHOLDER = /\{(\w+)\}/g

const isShared = (key: MessageKey): key is SharedMessageKey => key in en

export function t(key: MessageKey, vars?: MessageVars): string {
  if (isShared(key)) return tShared(key, vars)

  const template: string = messages[key] ?? key
  if (!vars) return template
  return template.replace(PLACEHOLDER, (match, name: string) =>
    name in vars ? String(vars[name]) : match,
  )
}

export type { MessageVars }
